// extracted by mini-css-extract-plugin
export default {"head":"Collection_head__ZpLkJ","mainn":"Collection_mainn__DgbD0"};